import { createVehiclesMap } from "./builders/createVehiclesMap";

export const vehicles = createVehiclesMap({
  cobra: {
    year: 1965,
    make: "Shelby",
    model: "Cobra 427",
    value: 1000000,
    vin: "63V17449",
  },
  superBee: {
    year: 1968,
    make: "Dodge",
    model: "Super Bee",
    value: 65000,
    vin: "4X37JH444493",
  },
  ferrari: {
    year: 1962,
    make: "Ferrari",
    model: "250 GTO",
    value: 48400000,
    vin: "1G2AM37R3EP255288",
  },
  sportScoutRacer: {
    year: 1936,
    make: "Indian",
    model: "Sport Scout Racer",
    value: 31250,
    vin: "63V174491",
  },
  crv: {
    year: 2020,
    make: "Honda",
    model: "CRV",
    value: 20000,
    vin: "JH2SC6607CK200223",
  },
  mustang: {
    year: 2022,
    make: "Ford",
    model: "Mustang",
    value: 25000000,
    vin: "1FA6P8CF5N5109624",
    hasIdCard: false,
  },
});

export const revalVehicles = createVehiclesMap({
  cobra: {
    year: 1965,
    make: "Shelby",
    model: "Cobra 427",
    value: 1000500,
    vin: "63V17449",
  },
  superBee: {
    year: 1968,
    make: "Dodge",
    model: "Super Bee",
    value: 65500,
    vin: "4X37JH444493",
  },
  ferrari: {
    year: 1962,
    make: "Ferrari",
    model: "250 GTO",
    value: 48400500,
    vin: "1G2AM37R3EP255288",
  },
  sportScoutRacer: {
    year: 1936,
    make: "Indian",
    model: "Sport Scout Racer",
    value: 31750,
    vin: "63V174491",
  },
  crv: {
    year: 2020,
    make: "Honda",
    model: "CRV",
    value: 25000,
    vin: "JH2SC6607CK200223",
  },
  mustang: {
    year: 2022,
    make: "Ford",
    model: "Mustang",
    value: 25000000,
    vin: "1FA6P8CF5N5109624",
  },
});

export type VehicleKey = keyof typeof vehicles;
